
import React from 'react';
import { useLanguage } from '../App';

const MarqueeBlocks: React.FC = () => {
  const { t } = useLanguage();
  const blocks = [
    { text: t.privateMastery, img: "1DxU1Mr6lsw8SNwiIU36IDHkxdbxBKNCa" },
    { text: t.eliteGrooming, img: "1j9FbYtuU3wqEXUyeN-7pJOyHXu8L0aki" },
    { text: t.conciergeCuts, img: "1OzqlkrJCW7_SbEYZBy57DNw_3NxsKCff" },
    { text: t.mobileLuxury, img: "1viSEgOXceZcDdhMYCmXwfO5hg8Ia7pQl" },
    { text: t.signatureStyle, img: "1euLWA3QMtH_3pWgYVHTnLm0aLevGpMdp" },
  ];

  return (
    <section className="py-6 sm:py-12 bg-black border-y border-white/5 overflow-hidden">
      <div className="relative flex overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap w-max">
          {[...blocks, ...blocks, ...blocks].map((block, idx) => (
            <div key={idx} className="inline-flex items-center mx-3 sm:mx-4 group">
              {/* Scaled up mobile width from 150px to 220px to match premium desktop vibe */}
              <div className="relative w-[220px] sm:w-[280px] h-[320px] sm:h-[420px] overflow-hidden bg-secondary shadow-2xl border border-white/5">
                <img 
                  src={`https://drive.google.com/thumbnail?id=${block.img}&sz=w800`} 
                  alt={block.text}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 scale-100 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-80 group-hover:opacity-60 transition-opacity"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <span className="block text-lg sm:text-xl font-serif font-bold text-white uppercase tracking-tighter group-hover:text-accent transition-colors whitespace-normal leading-tight">
                    {block.text}
                  </span>
                  <div className="w-8 h-px bg-accent mt-3 translate-x-0 group-hover:translate-x-2 transition-transform duration-500"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarqueeBlocks;
